/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filters_TitleInputs */



/**
* | output |
* | --- |
* | "Filters" |
*
* @param {Editor_Filters_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filters_title = /** @type {((inputs?: Editor_Filters_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filters_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Filter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("过滤器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フィルター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फिल्टर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtros")
	return /** @type {LocalizedString} */ ("Filters")
});